/**
 * @generated SignedSource<<f7ef115f33463b2303630b532f9f0896>>
 * @relayHash dfd64399dc6cd0deea43b3dc55d023a1
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/463.0.0-2024-05-21T07:50:23.801Z/IFramedPromoPartnershipPCFormMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubmitPromoPartnershipPrivateClientRecordInput = {
  clientMutationId?: string | null;
  priceRange: string;
  primaryInterest: string;
  privateAdvisorAssistance?: string | null;
  receiveSmsUpdates?: boolean | null;
  receiveWhatsAppUpdates?: boolean | null;
  smsPhoneNumber?: string | null;
  source: string;
  userId: string;
  whatsAppPhoneNumber?: string | null;
};
export type IFramedPromoPartnershipPCFormMutation$variables = {
  input: SubmitPromoPartnershipPrivateClientRecordInput;
};
export type IFramedPromoPartnershipPCFormMutation$data = {
  readonly submitPromoPartnershipPrivateClientRecord: {
    readonly recordId: string | null;
  } | null;
};
export type IFramedPromoPartnershipPCFormMutation = {
  response: IFramedPromoPartnershipPCFormMutation$data;
  variables: IFramedPromoPartnershipPCFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitPromoPartnershipPrivateClientRecordPayload",
    "kind": "LinkedField",
    "name": "submitPromoPartnershipPrivateClientRecord",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recordId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IFramedPromoPartnershipPCFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IFramedPromoPartnershipPCFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-misc/463.0.0-2024-05-21T07:50:23.801Z/IFramedPromoPartnershipPCFormMutation",
    "metadata": {},
    "name": "IFramedPromoPartnershipPCFormMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "00a17b0011fe3c4caf32b93140b6c37d";

export default node;
